<template>
  <div id="warningSet">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span style="font-size: 20px;margin-right: 20px;">{{ basicinfo.deviceName }}</span>
        <span style="font-size: 18px;">
          <el-link type="primary" @click="goToDetailgPage">({{ basicinfo.deviceSn }})</el-link>
        </span>

        <span class="fontStyle2" />
        <span class="fontStyle1"> {{ basicinfo.mechBrand||'--' }} / {{ basicinfo.mechType||'--' }} / {{ basicinfo.mechModel||'--' }} </span>
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ basicinfo.batteryBrand }} / {{ basicinfo.batteryCapacity }} Ah / {{ basicinfo.batteryVoltage }} V</span>
        
        <span class="fontStyle2" />
        <span class="fontStyle1">{{ $t("yhubReport.FirmwareVersion") }}: V{{ basicinfo.fwVersion }}</span>
        
      </div>
    </el-row>
    <!-- 警告功能配置 -->
    <el-row class="contentWarp">
      <p class="contentTitle">
        {{ $t("warningSet.warningSettings") }}
      </p>

      <!-- pan 警告配置-->
      <warn-set-form :battery-capacity="basicinfo.batteryCapacity" />
    </el-row>
    <!-- 警告信息-->
    <el-row class="contentWarp">
      <p class="contentTitle">
        {{ $t("yhubReport.WarningMessage") }}
        <!-- <el-button v-show="isShowCloseAllBtn" type="primary" style="vertical-align: top;margin-top: 7px;float: right;margin-left: 10px;" @click="closeAllWarnInfo()">全部关闭</el-button> -->
        <el-button v-if="$store.state.userInfo.guestFlag!=true" style="vertical-align: top;margin-top: 7px;float: right;margin-left: 10px;" type="primary" @click="closeAllWarnInfo()">{{ $t("warningSet.disableAll") }}</el-button>
      </p>
      <el-table :data="warnInfotableData" :default-sort="{prop: 'date', order: 'descending'}" border style="width: 100%">
        <el-table-column :label="$t('warningPage.CreatedAt')" align="center" min-width="10%" prop="createTime" sortable />
        <!-- <el-table-column :label="$t('warningPage.Content')" min-width="25%" prop="message" /> -->
        <el-table-column :label="$t('warningPage.Content')" min-width="25%" prop="message" align="center">
          <template slot-scope="scope">
            <p style="text-align: center;">
              {{ scope.row.message }}
              <span v-if="scope.row.msgType==4" style="color:red;">{{ $t('warningInfo.LevelWarn1') }}</span>
              <span v-else-if="scope.row.msgType==11" style="color:red;">{{ $t('warningInfo.LevelWarn2') }}</span>
              <span v-else-if="scope.row.msgType==12" style="color:red;">{{ $t('warningInfo.LevelWarn3') }}</span>
              <span v-else-if="scope.row.msgType==13" style="color:red;">{{ $t('warningInfo.LevelWarn4') }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('AllDevices.Status')" align="center" min-width="10%" prop="status" />
        <el-table-column :label="$t('warningPage.SovledAt')" align="center" min-width="10%" prop="updateTime" sortable />
        <el-table-column :label="$t('warningInfo.AlarmDuration')" align="center" min-width="12%" prop="warnDuration" />
        <el-table-column :label="$t('warningPage.Remark')" align="center" min-width="13%" prop="remark" />
        <el-table-column :label="$t('yhubReport.Operating')" align="center" min-width="10%" prop="action">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <!-- <el-button v-show="scope.row.delFlag==0" type="primary" icon="el-icon-circle-close " size="mini" @click="closeOneWarnInfo(scope.row)" /> -->
              <el-button v-if="$store.state.userInfo.guestFlag!=true" icon="el-icon-edit" size="mini" type="primary" @click="closeOneWarnInfo(scope.row)" />
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination
            v-if="pageshow"
            :page-size="listQuery.pageInfo.limit"
            :page-sizes="listQuery.pageInfo.pageList"
            :total="listQuery.pageInfo.total"
            background
            current-page.sync="listQuery.pageInfo.page"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>

      <!-- 关闭弹窗 -->
      <el-dialog :close-on-click-modal="false" :visible.sync="tableEditPopShow" width="60%">
        <el-form :inline="false" :model="tableRow" label-position="right" label-width="150px">
          <el-form-item :label="$t('warningPage.SovledAt')" prop="mm">
            <el-input v-model="tableRow.updateTime" :disabled="true" style="width: 80%" />
          </el-form-item>
          <el-form-item :label="$t('BondOrUpdateDevice.OwnedCompany')" prop="mm">
            <el-input v-model="tableRow.companyName" :disabled="true" style="width: 80%" />
          </el-form-item>
          <el-form-item :label="$t('dashboard.DeviceName')" prop="mm">
            <el-input v-model="tableRow.deviceName" :disabled="true" style="width: 80%" />
          </el-form-item>
          <el-form-item :label="$t('warningPage.Content')" prop="mm">
            <el-input v-model="tableRow.message" :disabled="true" style="width: 80%" />
          </el-form-item>
          <el-form-item :label="$t('AllDevices.Status')" prop="mm">
            <el-select v-model="tableRow.status" :placeholder="$t('AllDevices.Status')" class="filter-item" clearable filterable style="width: 80%" @change="changeStatus">
              <el-option v-for="(item,index) in statusOptions" :key="index" :label="item.label" :value="item.key" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('warningPage.Remark')" prop="mm">
            <el-input v-model="tableRow.remark" :autosize="{ minRows: 4, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" style="width: 80%" type="textarea" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="tableEditPopShow = false">{{ $t('button.Cancel') }}</el-button>
          <el-button class="filter-item" type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { findDeviceInfo, getLastOneMsgBMSData, findGeofenceDeviceList, updateGnssGeofenceStatus, getCompanyUserName,
 selectByMcuId, updatePushMsgUser, getwarningSettingByMcuId,
  updateWarningSetting, listWarningPushMsg2, updatePushMsgDelFlag, updateAllPushMsgDelFlag } from '@/api/warning'
import BarChartTwo from '@/components/BarChartTwo'
import { getDateAndHour, usedTime } from '@/utils/updateTime.js'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { temChangeUnit, temChange, temUnit, temHsdToSsd } from '@/utils/temChange.js'
import WarnSetForm from './components/WarnSetForm.vue'

export default {
  name: 'DashboardAdmin',
  components: {
    BarChartTwo,
    WarnSetForm
  },
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      basicinfo: {},
      viewTableData: [
        { key: 1, minName: 'minSoc', name: i18n.t('warningSet.lowSOCThreshold'), value: 30 },
        { key: 2, minName: 'maxSoc', name: i18n.t('warningSet.lowSocRecover'), value: 80 },
        { key: 3, minName: 'minTemp', name: i18n.t('warningSet.lowTemperature'), value: -50 },
        // { key: 4, minName: 'maxTemp1', name: i18n.t('warningSet.HighTemperature'), value: 90 },
        { key: 41, minName: 'maxTemp', name: '温度过高一级警告值大于', value: 90 },
        { key: 42, minName: 'maxTemp2', name: '温度过高二级警告值大于', value: 90 },
        { key: 43, minName: 'maxTemp3', name: '温度过高三级警告值大于', value: 90 },
        // { key: 44, minName: 'maxTemp4', name: '温度过高四级警告值大于', value: 90 },
        { key: 51, minName: 'voltageProtectionSwitch', name: i18n.t('warningSet.voltageProtectionSwitch'), value: 1, value1: 10 },
        { key: 5, minName: 'minV', name: i18n.t('warningSet.lowVoltage'), value: 75, value1: 0 },
        { key: 52, minName: 'lowVolLevel2', name: i18n.t('warningSet.lowVoltage2'), value: 70, value1: 0 },
        { key: 53, minName: 'lowVolLevel3', name: i18n.t('warningSet.lowVoltage3'), value: 65, value1: 0 },
        { key: 6, minName: 'maxV', name: i18n.t('warningSet.hightVoltage'), value: 148, value1: 0 },
        { key: 63, minName: 'recoveryVoltage', name: i18n.t('warningSet.recoveryVoltage'), value: 148, value1: 0 },

        // { key: 62, minName: 'halfVol', name: i18n.t('warningSet.HalfVThreshold'), value: null },
        // { key: 61, minName: 'auxVolOpen', name: i18n.t('warningSet.secondVLow'), value: '0' },
        { key: 7, minName: 'supportWaterLevel', name: i18n.t('allDeviceDetail.LevelWarning'), value: '0' },
        { key: 71, minName: 'offLine', name: '离线时长警告值大于(时)', value: 1 },
        { key: 8, minName: 'geofencing', name: i18n.t('location.geofencing'), value: '2' },
        { key: 81, minName: 'warningOpen', name: '告警总开关', value: '1' },
        { key: 10, minName: 'current', name: i18n.t('warningSet.current'), value: '', value1: '', value2: '' },
        { key: 9, minName: 'toPerson', name: i18n.t('warningSet.contactList'), value: '' }
      ],
      halfVol: null,
      halfVoltageDuration: null,
      isShowHalfVol: false,
      editTableData: [],
      viewTableData2: [],
      oldviewTableData: [],
      isShowEditTable: true,
      isShowOnOrOff: false,
      isSetElectric: null,
      isShowCloseAllBtn: true,
      warnInfotableData: [],
      geofenceStatus: null,
      owerPersonViewOptions: [], // 当前设备拥有人--查看
      owerPersonViewSelect: [], // 选中的当前设备拥有人--查看
      owerPersonOptions: [], // 当前设备拥有人--编辑
      owerPersonSelect: [], // 选中的当前设备拥有人--编辑

      tableEditPopShow: false,
      tableRow: {},
      myStatus: null,
      statusOptions: [
        // 状态选择下拉框数据--表格
        { key: 0, label: '未解决' },
        { key: 1, label: '已解决' }
      ],
      lithiumUpdateTime: null,
      noDate: false,
      waterDurationView: 5,
      waterDurationEdit: 5,
      minMaxVRight: true,
      offlineDurationView: 1,
      offlineDurationEdit: 1
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    },
    mcuId () {
      return this.$route.query.mcuId
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryWarnInfoTable()
      this.queryWarnSet()
    },
    mcuId () {
      this.queryList()
      this.queryWarnSet()
      this.queryWarnInfoTable()
    }
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next()
  },
  mounted() {
    console.log(987)
    this.queryList()
    this.queryWarnSet()
    this.queryWarnInfoTable()
  },
  methods: {
    queryList() {
      // 基本信息
      findDeviceInfo({ mcuId: this.$route.query.mcuId }).then(res => {
        // console.log(response)
        this.basicinfo = res.resultModel
        if (this.basicinfo.batteryCapacity) {
          this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? this.basicinfo.batteryCapacity / 100 : this.basicinfo.batteryCapacity
        } else {
          this.basicinfo.batteryCapacity = '--'
        }
        if (this.basicinfo.batteryVoltage) {
          this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? this.basicinfo.batteryVoltage / 100 : this.basicinfo.batteryVoltage
          this.viewTableData.forEach(v => {
            if ((v.key == 5 || v.key == 52 || v.key == 53 || v.key == 6 || v.key == 63) && !v.value1) v.value1 = this.getNum(v.value * this.basicinfo.batteryVoltage / 100)
          })
        } else {
          this.basicinfo.batteryVoltage = '--'
        }
        var hadHalfVol = this.viewTableData.some(v => { return v.minName == 'halfVol' })
        this.isShowHalfVol = res.resultModel.halfV == 1
        if (this.isShowHalfVol) { // 半电压打开才显示半电压设置
          if (!hadHalfVol) this.viewTableData.splice(12, 0, { key: 62, minName: 'halfVol', name: i18n.t('warningSet.HalfVThreshold'), value: this.halfVol, value1: this.halfVoltageDuration })
        }
        this.viewTableData.forEach(v => {
          if (v.minName == 'halfVol' && v.value != 0 && !v.value) {
            switch (this.basicinfo.batteryVoltage) {
              case 24: v.value = 200; break
              case 36: v.value = 150; break
              case 48: v.value = 100; break
              case 80: v.value = 60; break
            }
          }
        })
        if (this.basicinfo.deviceType.indexOf('e') > -1) {
          // 锂电池
          getLastOneMsgBMSData({ mcuId: this.$route.query.mcuId }).then(res => {
            if (res.resultModel && res.resultModel.yhubStime) { this.lithiumUpdateTime = res.resultModel.yhubStime } // 锂电池最后更新时间
          })
        }
      })
    },
    queryWarnSet() {
      // 警告设置
      
      this.viewTableData.forEach(v => {
        switch (v.key) {
          case 1: v.name = i18n.t('warningSet.lowSOCThreshold'); break
          case 2: v.name = i18n.t('warningSet.lowSocRecover'); break
          case 3: v.name = i18n.t('warningSet.lowTemperature').replace('℃', temUnit()); break
          case 41: v.name = i18n.t('warningSet.HighTemperature').replace('℃', temUnit()); break
          case 42: v.name = i18n.t('warningSet.HighTemperature2').replace('℃', temUnit()); break
          case 43: v.name = i18n.t('warningSet.HighTemperature3').replace('℃', temUnit()); break
          // case 44:v.name = i18n.t('warningSet.HighTemperature4').replace('℃', temUnit()); break
          case 5: v.name = i18n.t('warningSet.lowVoltage'); break
          case 51: v.name = i18n.t('warningSet.voltageProtectionSwitch'); break
          case 52: v.name = i18n.t('warningSet.lowVoltage2'); break
          case 53: v.name = i18n.t('warningSet.lowVoltage3'); break
          case 6: v.name = i18n.t('warningSet.hightVoltage'); break
          case 63: v.name = i18n.t('warningSet.recoveryVoltage'); break
          // case 61:v.name = i18n.t('warningSet.secondVLow'); break
          case 62: v.name = i18n.t('warningSet.HalfVThreshold'); break
          case 7: v.name = i18n.t('allDeviceDetail.LevelWarning'); break
          case 71: v.name = i18n.t('warningSet.OfflineTime'); break
          case 8: v.name = i18n.t('location.geofencing'); break
          case 81: v.name = i18n.t('warningSet.AlarmSwitch'); break
          case 9: v.name = i18n.t('warningSet.contactList'); break
          case 10: v.name = i18n.t('warningSet.current'); break
        }
      })
      // 警告配置表格数据
      getwarningSettingByMcuId({ mcuId: this.$route.query.mcuId }).then(res => {
        for (var i in res.resultModel) {
          this.viewTableData.forEach(v => {
            if (v.minName == i) v.value = res.resultModel[i]
            if (v.minName == 'supportWaterLevel') { v.value = !res.resultModel.supportWaterLevel ? '0' : res.resultModel.supportWaterLevel.toString() }
            if (v.minName == 'offLine') { v.value = !res.resultModel.offLine ? '0' : '1' }
            if (v.minName == 'auxVolOpen') { v.value = !res.resultModel.auxVolOpen ? '0' : res.resultModel.auxVolOpen.toString() }
            if (v.minName == 'warningOpen') { v.value = !res.resultModel.warningOpen ? '0' : res.resultModel.warningOpen.toString() }
            if (v.minName == 'voltageProtectionSwitch') {
              v.value = !res.resultModel.volProtectSwitch ? '0' : res.resultModel.volProtectSwitch.toString()
              v.value1 = !res.resultModel.voltageDuration ? '0' : res.resultModel.voltageDuration
            }
            if (v.minName == 'current') {
              v.value = !res.resultModel.chargeCurrent ? '0' : res.resultModel.chargeCurrent
              v.value1 = !res.resultModel.dischargeCurrent ? '0' : res.resultModel.dischargeCurrent
              v.value2 = !res.resultModel.currentDuration ? '0' : res.resultModel.currentDuration
            }
            this.halfVoltageDuration = res.resultModel.halfVoltageDuration
            this.halfVol = res.resultModel.halfVol
          })
          this.waterDurationView = this.waterDurationEdit = res.resultModel.waterDuration
          this.offlineDurationView = this.offlineDurationEdit = res.resultModel.offLine
        }
        if (res.resultModel) this.halfVol = res.resultModel.halfVol
        this.oldviewTableData = JSON.parse(JSON.stringify(this.viewTableData))
        this.viewTableData.forEach(v => {
          if (v.key == 3 || v.key == 41 || v.key == 42 || v.key == 43 || v.key == 44) {
            v.value = temChange(v.value)
          }
          if ((v.key == 5 || v.key == 52 || v.key == 53 || v.key == 6 || v.key == 63) && this.basicinfo.batteryVoltage && this.basicinfo.batteryVoltage != '--') v.value1 = this.getNum(v.value * this.basicinfo.batteryVoltage / 100)
        })
        this.editTableData = this.viewTableData
        
        var param = {
          companyIdList: [],
          key: this.$route.query.mcuId,
          orderBy: 1,
          pageNum: 1,
          pageSize: 10,
          status: -1
        }
        findGeofenceDeviceList(param).then(res => {
          // 电子围栏设置情况
          var v = res.resultModel.list[0]
          this.geofenceStatus = v.geofenceStatus
          
          this.viewTableData.forEach(v => {
            if (v.minName == 'geofencing') {
              if (!this.geofenceStatus) {
                // 未设置电子围栏
                v.value = '0'
              } else {
                // v.geofenceStatus  1:开启 其他：关闭
                v.value = this.geofenceStatus == 1 ? '3' : '2'
              }
            }
          })
        })
      })
      selectByMcuId({ mcuId: this.$route.query.mcuId }).then(res => {
        if (res.resultModel && res.resultModel.userNameList) {
          this.owerPersonViewOptions = res.resultModel.userNameList
          this.owerPersonSelect = this.owerPersonViewSelect = res.resultModel.userNameList
        }
      })
      getCompanyUserName({ mcuId: this.$route.query.mcuId }).then(res => {
        this.owerPersonOptions = res.resultModel
      })
    },
    inputBlur(val, index, key, attr) {
      console.log('val=' + val + ', index=' + index + ', key=' + key + ', attr=' + attr)
      // 输入框正则校验
      // if (val < 0 && (val.toString())[0] == '-') val = val.substr(1)
      // if (!/^[0-9]*$/.test(val)) {
      // if (!/^[0-9]*$/.test(val)) {
      if (!(/^[+,-]{0,1}[0-9][0-9]*(\.[0-9]{1,2})?$/.test(val))) { // 校验整数或小数(允许1-10位小数)
        document.getElementById('showWarn' + index).style.display = 'block'
        this.minMaxVRight = false
      } else {
        this.minMaxVRight = true
        document.getElementById('showWarn' + index).style.display = 'none'
      }
      if (key == 71) {
        if (!(/^[+]{0,1}(\d+)$/.test(val))) { // 校验整数
          document.getElementById('showWarn' + index).style.display = 'block'
          this.minMaxVRight = false
        } else {
          this.minMaxVRight = true
          document.getElementById('showWarn' + index).style.display = 'none'
        }
      }
      if (key == 5 || key == 52 || key == 53) {
        if (this.basicinfo.batteryVoltage && this.basicinfo.batteryVoltage != '--' && (attr == 'batteryVoltage1' && Number(val) >= this.basicinfo.batteryVoltage) || (attr == 'batteryVoltage2' && Number(val) >= 100)) {
          this.minMaxVRight = false
          document.getElementById('showValueWarnMin' + index).style.display = 'block'
        } else {
          this.minMaxVRight = true
          document.getElementById('showValueWarnMin' + index).style.display = 'none'
        }
      }
      if (key == 6) {
        if (this.basicinfo.batteryVoltage && this.basicinfo.batteryVoltage != '--' && (attr == 'batteryVoltage1' && Number(val) <= this.basicinfo.batteryVoltage) || (attr == 'batteryVoltage2' && Number(val) <= 100)) {
          this.minMaxVRight = false
          document.getElementById('showValueWarnMax' + index).style.display = 'block'
        } else {
          this.minMaxVRight = true
          document.getElementById('showValueWarnMax' + index).style.display = 'none'
        }
      }
      if (attr) {
        this.editTableData.forEach(v => {
          if ((v.key == 5 || v.key == 52 || v.key == 53 || v.key == 6 || v.key == 63) && this.basicinfo.batteryVoltage && this.basicinfo.batteryVoltage != '--') {
            if (attr == 'batteryVoltage1') { // 输入电压
              v.value = this.getNum(v.value1 / (this.basicinfo.batteryVoltage / 100))
            }
            if (attr == 'batteryVoltage2') {
              v.value1 = this.getNum(v.value * this.basicinfo.batteryVoltage / 100)
            }
          }
        })
      }
    },
    getNum(num) {
      num = (Math.round(num * 100) / 100).toFixed(2)
      return num
    },
    queryWarnInfoTable() { // 警告信息表格
      this.statusOptions[0].label = i18n.t('warningPage.Unsolved')
      this.statusOptions[1].label = i18n.t('warningPage.Solevd')
      var param = {
        companyIdList: [],
        endDate: new Date().getTime(), // 结束时间 2019-11-27 -> 时间戳,
        // startDate: new Date(getDateAndHour(new Date().getTime() - 30 * 24 * 60 * 60 * 1000, 'noTime')).getTime() - 8 * 60 * 60 * 1000, // 开始时间 2019-11-21 -> 时间戳
        startDate: 0, // 开始时间 2019-11-21 -> 时间戳
        delFlag: null,
        key: this.$route.query.mcuId,
        msgType: -1,
        // mcuId: this.$route.query.mcuId,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      listWarningPushMsg2(param).then(res => {
        // 警告信息列表数据
        if (res.resultCode === 1001) {
          if (!res.resultModel) {
            this.warnInfotableData = []
            return
          }
          this.warnInfotableData = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          for (var i = this.warnInfotableData.length - 1; i >= 0; i--) {
            var v = this.warnInfotableData[i]
            if (v.delFlag == 1) {
              v.warnDuration = usedTime(v.updateTime - v.createTime, 'noSecond')
              v.updateTime = getDateAndHour(v.updateTime, 'noSecond')
              v.status = i18n.t('warningPage.Solevd')
            } else {
              v.warnDuration = usedTime(Date.now() - v.createTime, 'noSecond')
              v.updateTime = '--'
              v.status = i18n.t('warningPage.Unsolved')
            }
            if (v.createTime) { v.createTime = getDateAndHour(v.createTime, 'noSecond') }
            if (v.msgType == 1) {
              if (v.triggerValue) {
                v.triggerValue = v.triggerValue > 100 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
              }
              v.message = i18n.t('warningInfo.batterySocLow1') + v.triggerValue + i18n.t(`warningInfo.batterySocLow2`)
            } else if (v.msgType == 2) {
              v.message = i18n.t('warningInfo.batteryWaterLow')
            } else if (v.msgType == 4 || v.msgType == 11 | v.msgType == 12 || v.msgType == 13) {
              if (v.triggerValue) {
                v.triggerValue = v.triggerValue > 1000 ? Math.round(v.triggerValue / 100) : Math.round(v.triggerValue)
              }
              v.message = i18n.t('warningInfo.batteryTemHeight1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemHeight2')
            } else if (v.msgType == 5) {
              v.message = i18n.t('warningInfo.batteryCapacity1') + v.triggerValue + i18n.t('warningInfo.batteryCapacity2')
            } else if (v.msgType == 6) {
              v.message = i18n.t('warningInfo.batteryNoPosition')
            } else if (v.msgType == 7) {
              v.message = i18n.t('warningInfo.batteryVoltageLow1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageLow2')
            } else if (v.msgType == 8) {
              v.message = i18n.t('warningInfo.batteryTemLow1') + temChangeUnit(v.triggerValue) + i18n.t('warningInfo.batteryTemLow2')
            } else if (v.msgType == 9) {
              v.message = i18n.t('warningInfo.batteryTemAbnormal')
            } else if (v.msgType == 10) {
              v.message = i18n.t('warningInfo.batteryVoltageHeight1') + v.triggerValue + i18n.t('warningInfo.batteryVoltageHeight2')
            } else if (v.msgType == 15) {
              v.message = i18n.t('warningInfo.HalfVWarn')
            } else if (v.msgType == 16) {
              v.message = i18n.t('warningInfo.offlineWarn').replace('$1', v.triggerValue)
            } else if (v.msgType == 17) {
              v.message = i18n.t('warningInfo.linChargeOverWarn')
            } else if (v.msgType == 18) {
              if (v.triggerValue) { v.triggerValueZh = getDateAndHour(v.triggerValue, 'noTime') }
              v.message = i18n.t('warningInfo.overTiemTo').replace('$1', v.triggerValueZh)
            } else if (v.msgType == 19) {
              v.message = i18n.t('warningInfo.overTiem')
            } else if (v.msgType == 20) {
              v.message = i18n.t('warningSet.chargeDisAbnormalWarn')
            } else if (v.msgType == 21) {
              v.message = i18n.t('warningInfo.unitVLowWarn')
            } else {
              this.warnInfotableData.splice(i, 1)
            }
          }
          var arr = this.warnInfotableData
          var every = arr.every(function(val, index, arr) {
            return val.delFlag >= 1 // 解决
          })
          // if (every) { this.isShowCloseAllBtn = false } else { this.isShowCloseAllBtn = true }

          console.log(every) // 返回false
        }
      })
    },
    goToElectricFence() {
      // 进入电子围栏页
      var routeData = this.$router.resolve({
        path: '/locationMagt/electricFence',
        query: {
          mcuId: this.$route.query.mcuId,
          sn: this.basicinfo.deviceSn,
          deviceName: this.basicinfo.deviceName,
          geofenceStatus: this.geofenceStatus
        }
      })
      window.open(routeData.href, '_self')
    },
    goToDetailgPage() {
      // 去详情页
      var routeData
      if (this.basicinfo.deviceType.indexOf('e') == -1) {
        // 非锂电池
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceDetail',
          query: {
            mcuId: this.$route.query.mcuId,
            deviceType: this.basicinfo.deviceType,
            sn: this.basicinfo.deviceSn
            // id: this.basicinfo.id
          }
        })
      } else {
        var endtime = Date.parse(new Date(this.lithiumUpdateTime))
        routeData = this.$router.resolve({
          path: '/allDevices/lithiumChartPage',
          query: {
            mcuId: this.$route.query.mcuId,
            deviceName: this.basicinfo.deviceName,
            endTime: endtime,
            sn: this.basicinfo.deviceSn
          }
        })
      }
      window.open(routeData.href, '_self')
    },
    submitTable() {
      // 警告配置--提交
      var param = {
        batteryType: 2,
        companyId: 34,
        errTemp: 100,
        maxSoc: 80,
        maxTemp: 50,
        maxTemp2: 50,
        maxTemp3: 50,
        // maxTemp4: 50,
        maxV: 240,
        mcuId: this.$route.query.mcuId,
        minSoc: 20,
        minSoh: 30,
        minTemp: -99,
        minV: 10,
        supportWaterLevel: 1,
        auxVolOpen: 0,
        updateById: this.$store.state.companyId,
        warningOpen: 1,
        waterDuration: this.waterDurationEdit,
        offLine: this.offlineDurationEdit,
        // halfVol: 0
        volProtectSwitch: 0,
        lowVolLevel2: 0,
        lowVolLevel3: 0,
        recoveryVoltage: 0,
        voltageDuration: 10,
        halfVoltageDuration: 10,
        chargeCurrent: 1000,
        dischargeCurrent: 1000,
        currentDuration: 10,
        status: 1,
        configFrom: 'admin'
      }
      console.log(this.editTableData)
      for (var i in param) {
        for (var j = 0; j < this.editTableData.length; j++) {
          var v = this.editTableData[j]
          if (v.minName == i) {
            if (v.key == 3 || v.key == 41 || v.key == 42 || v.key == 43 || v.key == 44) {
              // 提交保存时，将温度还原成摄氏度再提交
              param[i] = temHsdToSsd(v.value)
            } else {
              param[i] = Number(v.value)
            }
          }
          if (this.isShowHalfVol && v.minName == 'halfVol') param.halfVol = Number(v.value) // 半电压开关打开才传半电压设定值
        }
      }
      if (!this.minMaxVRight) return // 避免原本为false，却因为下面的循环变成了true
      this.editTableData.forEach((v, i) => { // 因为有之前的数据未做值的校验，避免minV和maxV值不满足条件，又未触发inputBlur的情况下提交失败
        if (v.key == 5 || v.key == 52 || v.key == 53 || v.key == 6 || v.key == 63) {
          if (v.value1.length > 0) this.inputBlur(Number(v.value1), i, v.key, 'batteryVoltage1')
          this.inputBlur(v.value, i, v.key, 'batteryVoltage2')
        } else if (v.key == 71) {
          if (v.value == 1) {
            param.offLine = Number(this.offlineDurationEdit)
            this.inputBlur(v.value, i, v.key)
          } else {
            param.offLine = 0
          }
        } else if (v.key == 10) {
          this.inputBlur(v.value, i, v.key)
          this.inputBlur(v.value1, i + '1', v.key)
          this.inputBlur(v.value2, i + '2', v.key)
        }
      })
      if (!this.minMaxVRight) return

      this.editTableData.forEach((v, i) => {
        if (v.key == 51) {
          param.volProtectSwitch = v.value
          param.voltageDuration = v.value1
        } else if (v.key == 52) {
          param.lowVolLevel2 = v.value
        } else if (v.key == 53) {
          param.lowVolLevel3 = v.value
        } else if (v.key == 63) {
          param.recoveryVoltage = v.value
        } else if (v.key == 62) {
          param.halfVoltageDuration = v.value1
        } else if (v.key == 10) {
          param.chargeCurrent = v.value
          param.dischargeCurrent = v.value1
          param.currentDuration = v.value2
        }
      })

      var param1 = {
        mcuId: this.$route.query.mcuId,
        updateById: this.$store.state.companyId,
        userNameList: this.owerPersonSelect
      }
      var showWarnArr = document.getElementsByClassName('showWarn')
      for (var j = 0; j < showWarnArr.length; j++) {
        if (showWarnArr[j].style.display != 'none') {
          console.log('校验错误')
          return
        }
      }
      // console.log(param)
      this.$confirm(i18n.t('basicinfo.submitChange'), '', {// '是否提交修改？'
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        updatePushMsgUser(param1).then(res => {
          // 提交推送人
        })
        // param.warningOpen = 1
        updateWarningSetting(param).then(res => {
          // 提交配置
          if (res.resultCode == 1001) {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted')
            })
            // this.isShowEditTable = false
            this.queryWarnSet()
          }
        })
      })
    },
    isSetElectricChange(value) {
      // 是否设置电子围栏
      if (value == 1) {
        this.isShowOnOrOff = true
        this.isSetElectric = '3'
      } else {
        this.isShowOnOrOff = false
      }
    },
    select(value) {
      console.log(value)
      // openElectricFence(index, mcuId, electricFenceOn) { // 是否开启电子围栏
      // console.log(electricFenceOn)
      if (value == 'close') {
        // 关闭电子围栏
        this.$confirm(i18n.t('location.disableGeofencing'), '', {
          // 是否关闭电子围栏
          confirmButtonText: i18n.t('button.Confirm'),
          cancelButtonText: i18n.t('button.Cancel'),
          type: 'warning'
        })
          .then(() => {
            updateGnssGeofenceStatus({
              mcuId: this.$route.query.mcuId,
              status: 0
            }).then(res => {
              if (res.resultCode == '1001') {
                // this.queryList()
                this.$message({
                  type: 'success',
                  message: i18n.t('location.disabled') // '成功关闭电子围栏!'
                })
              }
            })
          })
          .catch(() => {
            // this.tableData[index].electricFenceOn = true
            // this.$message({
            //   type: 'info',
            //   message: '已取消开启电子围栏'
            // })
          })
      } else {
        this.$confirm(i18n.t('location.enableGeofencing'), '', {
          // '是否开启电子围栏?'
          confirmButtonText: i18n.t('button.Confirm'), // '确定',
          cancelButtonText: i18n.t('button.Cancel'), // '取消',
          type: 'warning'
        })
          .then(() => {
            updateGnssGeofenceStatus({
              mcuId: this.$route.query.mcuId,
              status: 1
            }).then(res => {
              if (res.resultCode == '1001') {
                this.$message({
                  type: 'success',
                  message: i18n.t('location.enabled') // '成功开启电子围栏!'
                })
              }
            })
          })
          .catch(() => {
            // this.tableData[index].electricFenceOn = false
          })
      }
    },
    closeEdit() {
      // 取消编辑
      this.isShowEditTable = false
      this.viewTableData = this.oldviewTableData
      this.editTableData = this.viewTableData
      this.queryWarnSet()
    },
    closeOneWarnInfo1(row) {
      // 警告信息表格--单条信息关闭
      var param = {
        delFlag: 1,
        id: row.id,
        remark: row.remark
      }
      this.$confirm('是否关闭本条警告？', '', {
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        this.submitPop()
        // updatePushMsgDelFlag(param).then(res => {
        //   if (res.resultCode == '1001') {
        //     this.queryWarnInfoTable()
        //     this.$message({
        //       type: 'success',
        //       message: '成功关闭本条警告!' //
        //     })
        //   }
        // })
      }).catch(() => { })
    },
    closeOneWarnInfo(row) {
      // 警告信息表格--单条信息关闭
      this.tableEditPopShow = true
      this.tableRow = JSON.parse(JSON.stringify(row))
      // this.tableRow = row
    },

    changeStatus() {
      if (this.tableRow.status == i18n.t('warningPage.Unsolved')) { this.myStatus = 0 }
      if (this.tableRow.status == i18n.t('warningPage.Solevd')) { this.myStatus = 1 }
    },
    submitPop() {
      // 弹窗--提交
      // var myStatus
      console.log(this.tableRow.status)
      if (this.tableRow.status == i18n.t('warningPage.Unsolved') || this.tableRow.status == 0) { this.myStatus = 0 }
      if (this.tableRow.status == i18n.t('warningPage.Solevd') || this.tableRow.status == 1) { this.myStatus = 1 }
      var param = {
        delFlag: this.myStatus,
        // delFlag: 1,
        id: this.tableRow.id,
        remark: this.tableRow.remark
      }
      switch (param.delFlag) {
        case '未解决': param.delFlag = 0; break
        case '已解决': param.delFlag = 1; break
      }
      updatePushMsgDelFlag(param).then(res => {
        // 弹窗--提交
        if (res.resultCode === 1001) {
          this.tableEditPopShow = false
          this.queryWarnInfoTable()
          this.$message({
            type: 'success',
            message: i18n.t('warningSet.submitted')
          })
        }
      })
    },
    closeAllWarnInfo() {
      // 警告信息表格--全部信息关闭
      var param = {
        delFlag: 1,
        mcuId: this.$route.query.mcuId,
        remark: ''
      }
      this.$confirm(i18n.t('warningSet.disableAllWarning'), '', {
        // '是否关闭全部警告？'
        confirmButtonText: i18n.t('button.Confirm'), // '确定',
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      })
        .then(() => {
          updateAllPushMsgDelFlag(param).then(res => {
            if (res.resultCode == '1001') {
              this.queryWarnInfoTable()
              this.$message({
                type: 'success',
                message: i18n.t('warningSet.Succeed') // '成功关闭全部警告!' //
              })
            }
          })
        })
        .catch(() => { })
    },
    change(e) {
      this.$forceUpdate()
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryWarnInfoTable()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryWarnInfoTable()
    }
    // 分页----end
  }
}
</script>

<style lang="scss">
p {
  margin: 0;
}
#warningSet {
  .contentTitle {
    height: 50px;
    line-height: 50px;
    // border-bottom: 2px solid #e6e9ed;
    font-weight: bold;
  }
  .contentWarp {
    background: #fff;
    margin-top: 20px;
    padding: 20px;
  }
  .el-table {
    padding: 1px;
  }
  .el-input,
  .el-select {
    width: 60%;
  }
  .el-select .el-input {
    width: 100%;
  }
  .smailSelect  .el-input--medium{
    width: 100%!important;
  }
  .el-cascader,.el-cascader .el-input{
    width: 100%!important;
  }
  .el-input--medium .el-input__inner {
    text-align: left;
  }
  .el-radio__input.is-disabled + span.el-radio__label {
    color: #606266;
  }
  .el-radio__input.is-disabled.is-checked .el-radio__inner {
    border-color: #b4b5b5;
  }
  .el-table__header-wrapper {
    padding-bottom: 1px;
  }
  .supportWaterLevel,
  .offLine {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .voltageDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
    }
    span:nth-of-type(1) {
      width: calc(50% - 6px);
      text-align: right;
    }
    span:nth-of-type(2) {
      width: 2px;
      margin: 0 5px;
    }
    span:nth-of-type(3) {
      width: calc(50% - 6px);
      text-align: left;
    }
  }
  .voltageDiv1 {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

